module.exports = __webpack_public_path__ + "static/img/4en.240664c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/4en.png
// module id = S92X
// module chunks = 0